import React from 'react';
import {
  Smartphone, Globe, Server, Cloud, Shield, Cpu, ArrowRight,
} from 'lucide-react';

const services = [
  {
    icon: Smartphone,
    title: 'Mobile Development',
    description: 'Native and cross-platform mobile applications that deliver exceptional user experiences across iOS and Android devices.',
    features: ['React Native', 'Flutter', 'Native iOS/Android', 'Progressive Web Apps'],
  },
  {
    icon: Globe,
    title: 'Web Applications',
    description: 'Scalable, responsive web applications built with modern frameworks and best practices for optimal performance.',
    features: ['React/Next.js', 'Vue/Nuxt', 'Angular', 'Full-stack Solutions'],
  },
  {
    icon: Server,
    title: 'Backend Development',
    description: 'Robust server-side solutions with secure APIs, efficient databases, and microservices architecture.',
    features: ['Node.js', 'Python/Django', 'Java/Spring', 'GraphQL/REST APIs'],
  },
  {
    icon: Cloud,
    title: 'Cloud Solutions',
    description: 'Cloud-native applications with auto-scaling, high availability, and cost-optimized infrastructure.',
    features: ['AWS/Azure/GCP', 'Kubernetes', 'Serverless', 'DevOps/CI/CD'],
  },
  {
    icon: Shield,
    title: 'Security & Compliance',
    description: 'Enterprise-grade security implementations with compliance to industry standards and regulations.',
    features: ['OAuth/JWT', 'Encryption', 'GDPR/HIPAA', 'Security Audits'],
  },
  {
    icon: Cpu,
    title: 'AI & Machine Learning',
    description: 'Intelligent applications powered by machine learning models and artificial intelligence.',
    features: ['Natural Language Processing', 'Computer Vision', 'Predictive Analytics', 'ChatGPT Integration'],
  },
];

const Services = () => {
  return (
    <section id="services" className="relative py-24 md:py-32">
      <div className="frame">
        {/* Section masthead */}
        <header className="grid grid-cols-12 gap-x-6 lg:gap-x-10 items-end pb-6 border-b border-ink">
          <div className="col-span-12 lg:col-span-5 flex items-center gap-3">
            <span className="section-num">02 / Services</span>
            <span className="label-muted">Our capabilities</span>
          </div>
          <div className="col-span-12 lg:col-span-7 mt-6 lg:mt-0">
            <h2 className="display-lg">
              Our <span className="text-accent">Services</span>
            </h2>
            <p className="mt-5 max-w-measure text-ink-soft leading-relaxed">
              Comprehensive application development services tailored to meet your
              unique business needs and drive digital transformation.
            </p>
          </div>
        </header>

        {/* Cards grid */}
        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <article key={s.title} className="card-tech p-6 md:p-7 group">
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center justify-center w-12 h-12 bg-paper-3 border border-rule-soft group-hover:bg-lime group-hover:border-ink transition-colors">
                    <Icon className="w-5 h-5 text-ink" strokeWidth={1.5} />
                  </div>
                  <span className="label-muted">0{i + 1} / 06</span>
                </div>

                <h3 className="font-display font-semibold text-xl md:text-[1.5rem] tracking-tight text-ink leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-ink-soft leading-relaxed text-[15px]">
                  {s.description}
                </p>

                <ul className="mt-6 pt-5 border-t border-rule-soft space-y-2">
                  {s.features.map((t) => (
                    <li key={t} className="flex items-baseline gap-2.5 font-mono text-[12px] text-ink-soft">
                      <ArrowRight className="w-3 h-3 text-accent flex-shrink-0 translate-y-[1px]" strokeWidth={2} />
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
